// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ctFdcV {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.jsuMCT {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.KnWcRQ {
  margin: 0;
  padding: 8px 12px;
  background: var(--surface-2);
  border: 1px solid var(--border);
  border-radius: 6px;
  color: var(--text-muted);
  font-size: 13px;
}

.LVn4wj {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.XXiDMH {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.mgyJbA {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.cQyKbp {
  flex: 1 1 200px;
  min-width: 160px;
}

.yOc82_ {
  display: flex;
  align-items: center;
  gap: 6px;
}

.yOc82_ input {
  width: 90px;
}
`, "",{"version":3,"sources":["webpack://./app/src/components/TimelinePlayer.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,4BAA4B;EAC5B,+BAA+B;EAC/B,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;AACb","sourcesContent":[".player {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.head {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.loading {\n  margin: 0;\n  padding: 8px 12px;\n  background: var(--surface-2);\n  border: 1px solid var(--border);\n  border-radius: 6px;\n  color: var(--text-muted);\n  font-size: 13px;\n}\n\n.error {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.controls {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.headRight {\n  display: inline-flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n}\n\n.progress {\n  flex: 1 1 200px;\n  min-width: 160px;\n}\n\n.volume {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.volume input {\n  width: 90px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"player": `ctFdcV`,
	"head": `jsuMCT`,
	"loading": `KnWcRQ`,
	"error": `LVn4wj`,
	"controls": `XXiDMH`,
	"headRight": `mgyJbA`,
	"progress": `cQyKbp`,
	"volume": `yOc82_`
};
export default ___CSS_LOADER_EXPORT___;
